export default "__VITE_ASSET__cf1ffc99__"